import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import { btnDelay, usePlaySound } from "common/utils";
import { actions } from "features/course/slice";
import { Course } from "features/courses/types";
import { LevelMap } from "./LevelMap";

export const SokobanLevelSelectPage = () => {
  const play = usePlaySound();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedLevel = useSelector(
    (state: RootState) => state.course.selectedLevelByCourse[Course.SOKOBAN] ?? 1,
  );

  const handleLevelPress = (levelId: number) => {
    play();
    dispatch(actions.updateSelectedLevel({ course: Course.SOKOBAN, level: levelId }));
    btnDelay(() => navigate(`/courses/${Course.SOKOBAN}/level/${levelId}`));
  };

  return (
    <div className="flex-col-el relative w-full h-full bg-[#F5FCFF]">
      <LevelMap onLevelPress={handleLevelPress} initialLevelId={selectedLevel} />
    </div>
  );
};
